/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from "@angular/core";
import { GetSalesforceDataService } from "app/services/salesforce-data";
import { ActivatedRoute, Router } from "@angular/router";
import { SalesforceMapperService } from "app/services/salesforce-mapper.service";

@Component({
  selector: "app-landing-explore",
  templateUrl: "./landing-explore.component.html",
  styleUrls: ["./landing-explore.component.scss"],
})
export class LandingExploreComponent implements OnInit {
  programDetail: any[] = [];
  currentIndex: number = 0;
  localStorageKey = "cachedProgramsData";

  constructor(
    private _getSalesforceDataService: GetSalesforceDataService,
    private salesforceMapper: SalesforceMapperService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const programId = params.get("id");
      const communityId = params.get("communityId");
      if (programId && communityId) {
        this.loadProgramData(programId, communityId);
      }
    });
  }

  navigateToHome(): void {
    this.router.navigate(["/home-landing"]);
  }

  navigateToExploreProgram(): void {
    this.router.navigate(["/explore-programs"]);
  }

  getCleanImage(imageData: string): string | null {
    if (!imageData) return null;
    const withoutTags = imageData.replace(/<\/?[^>]+(>|$)/g, "");
    const cleanData = withoutTags.replace(/&quot;/g, "").trim();
    if (cleanData.startsWith("data:image/") && cleanData.includes("base64,")) {
      return cleanData;
    }
    return null;
  }

  loadProgramData(programId: string, communityId: string) {
    const cachedData = localStorage.getItem(this.localStorageKey);

    if (cachedData) {
      try {
        const cachePayload = JSON.parse(cachedData);

        if (Array.isArray(cachePayload.data)) {
          this.setProgramDetail(cachePayload.data, programId, communityId);
          return;
        } else {
          localStorage.removeItem(this.localStorageKey);
        }
      } catch (e) {
        console.error("[Cache Error] Failed to parse cached data", e);
        localStorage.removeItem(this.localStorageKey);
      }
    } else {
      this.getDataFromSalesforce(programId, communityId);
    }
  }

  getDataFromSalesforce(programId: string, communityId?: string) {
    this._getSalesforceDataService.getDataFromSalesforce().subscribe(
      (response) => {
        if (response.success) {
          try {
            const dataSet = JSON.parse(response.msg);
            if (dataSet.data?.lstPrograms) {
              const today = new Date();
              today.setHours(0, 0, 0, 0);

              // ✅ Filter before mapping/caching
              const validPrograms = dataSet.data.lstPrograms.filter(
                (program: any) => {
                  if (!program.End_Date__c) return false;
                  const endDate = new Date(program.End_Date__c);
                  endDate.setHours(0, 0, 0, 0);
                  return program.Is_Active__c === true && endDate >= today;
                }
              );

              // ✅ Use the mapper
              const mappedPrograms =
                this.salesforceMapper.mapPrograms(validPrograms);

              const cachePayload = {
                timestamp: Date.now(),
                data: mappedPrograms,
              };

              localStorage.setItem(
                this.localStorageKey,
                JSON.stringify(cachePayload)
              );

              this.setProgramDetail(mappedPrograms, programId, communityId);
            } else {
              console.error("[Salesforce] No lstPrograms in response");
            }
          } catch (err) {
            console.error("[Salesforce Error] Invalid JSON", err);
          }
        } else {
          console.error("[Salesforce API error]", response);
        }
      },
      (error) => {
        console.error("[Salesforce Request Failed]", error);
      }
    );
  }

  private setProgramDetail(
    programs: any[],
    programId: string,
    communityId?: string
  ) {
    // ✅ Assign all valid programs directly
    this.programDetail = programs;

    // ✅ Find current program index
    const selectedIndex = this.programDetail.findIndex(
      (p) => p.id === programId
    );
    this.currentIndex = selectedIndex >= 0 ? selectedIndex : 0;
  }

  prevProgram() {
    if (this.programDetail.length === 0) return;
    this.currentIndex =
      (this.currentIndex - 1 + this.programDetail.length) %
      this.programDetail.length;
    this.updateUrl();
  }

  nextProgram() {
    if (this.programDetail.length === 0) return;
    this.currentIndex = (this.currentIndex + 1) % this.programDetail.length;
    this.updateUrl();
  }

  updateUrl() {
    const programId = this.programDetail[this.currentIndex]?.id;
    const communityId = this.programDetail[this.currentIndex]?.communityId;
    if (programId && communityId) {
      this.router.navigate(["/explore-program", programId, communityId], {
        replaceUrl: true,
      });
    }
  }

  navigateToSignUp() {
    const programId = this.programDetail[this.currentIndex]?.id;
    const programCommunity = this.programDetail[this.currentIndex]?.communityId;
    if (programId && programCommunity) {
      localStorage.setItem("ProgramId", programId);
      localStorage.setItem("communityId", programCommunity);
      this.router.navigate(["/sign-up"], {
        queryParams: { programId: programId, communityId: programCommunity },
      });
    }
  }

  navigateToSignIn() {
    const programId = this.programDetail[this.currentIndex]?.id;
    const programCommunity = this.programDetail[this.currentIndex]?.communityId;
    if (programId) {
      localStorage.setItem("ProgramId", programId);
      localStorage.setItem("communityId", programCommunity);
      this.router.navigate(["/sign-in"], {
        queryParams: { programId: programId, communityId: programCommunity },
      });
    }
  }
}
